import {
  Box,
  Button,
  CircularProgress,
  createStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  Chip,
  useTheme,
  useMediaQuery,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { makeStyles, withStyles } from "@material-ui/styles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { toast } from "react-toastify";
import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import InputSearch from "components/InputSearch";
import { ListParams } from "models/common";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { dateTimeToFormatYYYY } from "utils/dateTimeFormat";
import { timeConvert } from "utils/timeConvert";
import { ListResponseExam, ListExam } from "models/managerTest";
import managerTestApi from "api/managerTest";
import { useConfirm } from "material-ui-confirm";
import {
  fetchListExam,
  SelectFilterListExam,
  SelectListExam,
  selectLoadingListExam,
  setFilterListExam,
} from "./managerExamListSlice";
import moment from "moment";
import EmptyComponent from "components/Empty";
import { fetchDataOptions, selectListClass } from "features/Auth/options/optionsSlice";
import { IClass } from "models/managerClass";
import { BASE_URL, TOKEN } from "constants/config";
import axios, { AxiosResponse } from "axios";
import FileDownload from "js-file-download";
import RescheduleExamModal from "./components/RescheduleExamModal";

export interface ManagerExamProps { }

export default function ManagerExam(props: ManagerExamProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    pageWrapper: {
      maxWidth: 1280,
      margin: "0 auto",
      width: "100%",
    },
    background: {
      background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
      borderRadius: 24,
      padding: "32px 36px",
      color: "#FFFFFF",
      marginBottom: 28,
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 20,
      minHeight: 120,
      boxSizing: "border-box",
      [theme.breakpoints?.down("sm")]: {
        padding: "20px 18px",
        borderRadius: 16,
        minHeight: "auto",
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: "-40%",
        right: "-10%",
        width: 300,
        height: 300,
        background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
        pointerEvents: "none",
      },
      "& >h6": {
        color: "#FFFFFF !important",
        fontSize: "1.75rem !important",
        fontWeight: "800 !important",
        margin: "0 !important",
        position: "relative !important",
        left: "auto !important",
        top: "auto !important",
        bottom: "auto !important",
        zIndex: 2,
        [theme.breakpoints?.down("sm")]: {
          fontSize: "1.25rem !important",
        },
      },
    },

    btn_listExam: {
      color: "#2563EB",
      backgroundColor: "#EFF6FF",
      border: "1px solid #BFDBFE",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "4px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#2563EB",
        color: "#FFFFFF",
        borderColor: "#2563EB",
        boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)",
      },
    },
    btn_delete: {
      color: "#DC2626",
      backgroundColor: "#FEF2F2",
      border: "1px solid #FCA5A5",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "4px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#DC2626",
        color: "#FFFFFF",
        borderColor: "#DC2626",
        boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
      },
    },
    btn_edit: {
      color: "#059669",
      backgroundColor: "#ECFDF5",
      border: "1px solid #A7F3D0",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "4px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#059669",
        color: "#FFFFFF",
        borderColor: "#059669",
        boxShadow: "0 4px 12px rgba(5, 150, 105, 0.25)",
      },
    },
    btn_detail: {
      color: "#4F46E5",
      backgroundColor: "#EEF2FF",
      border: "1px solid #C7D2FE",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "4px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#4F46E5",
        color: "#FFFFFF",
        borderColor: "#4F46E5",
        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.25)",
      },
    },
    btn_list_missing: {
      color: "#7C3AED",
      backgroundColor: "#F5F3FF",
      border: "1px solid #DDD6FE",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "4px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#7C3AED",
        color: "#FFFFFF",
        borderColor: "#7C3AED",
        boxShadow: "0 4px 12px rgba(124, 58, 237, 0.25)",
      },
    },
    filterToolbar: {
      position: "sticky",
      top: 76,
      zIndex: 10,
      backdropFilter: "blur(12px)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      padding: "14px 20px",
      borderRadius: 16,
      marginBottom: 20,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 16,
      transition: "all 0.25s ease-in-out",
      [theme.breakpoints?.down("sm")]: {
        top: 68,
        padding: "14px 16px",
        flexDirection: "column",
        alignItems: "stretch",
      },
    },
    stickyActive: {
      backgroundColor: "#FFFFFF !important",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08) !important",
      borderColor: "#CBD5E1 !important",
    },
    container: {
      borderRadius: 20,
      border: "1px solid #E2E8F0",
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
      backgroundColor: "#FFFFFF",
      overflow: "visible",
      "& .MuiButton-root.Mui-disabled": {
        backgroundColor: "#F1F5F9 !important",
        color: "#94A3B8 !important",
        border: "1px dashed #CBD5E1 !important",
        boxShadow: "none !important",
        opacity: "0.9 !important",
        cursor: "not-allowed !important",
        pointerEvents: "auto !important",
      },
      "@media (max-width: 920px)": {
        display: "none",
      },
    },
    mobileListView: {
      display: "none",
      "& .MuiButton-root.Mui-disabled": {
        backgroundColor: "#F1F5F9 !important",
        color: "#94A3B8 !important",
        border: "1px dashed #CBD5E1 !important",
        boxShadow: "none !important",
        opacity: "0.9 !important",
        cursor: "not-allowed !important",
        pointerEvents: "auto !important",
      },
      "@media (max-width: 920px)": {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "16px",
        padding: "16px 0",
      },
      "@media (max-width: 600px)": {
        gridTemplateColumns: "1fr",
        padding: "12px 0",
      },
    },
    mobileCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      padding: 16,
      marginBottom: 0,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.02)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    mobileCardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 12,
    },
    mobileCardBody: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      marginBottom: 14,
      backgroundColor: "#F8FAFC",
      padding: "12px 14px",
      borderRadius: 10,
    },
    mobileCardRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    mobileCardActions: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 8,
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      "& .MuiButton-root": {
        width: "100%",
        justifyContent: "center",
        textAlign: "center",
        padding: "6px 4px",
        fontSize: "0.75rem",
        whiteSpace: "nowrap",
      },
    },
    paginationContainer: {
      marginTop: 16,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#FFFFFF",
      padding: "16px 24px",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
      [theme.breakpoints?.down("sm")]: {
        flexDirection: "column",
        gap: 12,
        padding: "16px 12px",
        borderRadius: 12,
      },
    },
  }));

  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        backgroundColor: "#F8FAFC",
        color: "#0F172A",
        fontSize: 12,
        fontWeight: 700,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "2px solid #E2E8F0",
        top: "0 !important",
        zIndex: 99,
        [theme.breakpoints?.up("xl")]: {
          fontSize: 14,
        },
      },
      body: {
        padding: "12px 14px",
        fontSize: 12,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        fontWeight: 500,
        color: "#334155",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const confirm = useConfirm();
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const filter = useAppSelector(SelectFilterListExam);
  const listExam = useAppSelector(SelectListExam);
  const loading = useAppSelector(selectLoadingListExam);
  const classList = useAppSelector(selectListClass);
  const [rescheduleExam, setRescheduleExam] = React.useState<ListExam | null>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [listExam]);

  useEffect(() => {
    dispatch(fetchListExam(filter));
  }, [dispatch, filter]);

  useEffect(() => {
    dispatch(fetchDataOptions());
  }, [dispatch]);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 180) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSearchChange = (newFilter: ListParams) => {
    dispatch(setFilterListExam({
      ...filter,
      ...newFilter,
      page: 0,
    }));
  };

  const handleFilterTypeChange = (typeVal: string) => {
    dispatch(
      setFilterListExam({
        ...filter,
        type: typeVal,
        page: 0,
      })
    );
  };

  const handleFilterClassChange = (classVal: string) => {
    dispatch(
      setFilterListExam({
        ...filter,
        classId: classVal ? Number(classVal) : undefined,
        page: 0,
      })
    );
  };

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filter,
        page: page - 1,
      })
    );
  };
  const deleteExam = async (exam: any) => {
    confirm({
      title: (
        <Typography variant="h5" color="secondary">
          {t("delete.chuy")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{ color: "#004673" }}>
            {" "}
            {exam.examTitle}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}>{t("delete.dongy")}</Button>,
      cancellationText: (
        <Button className={classes.btn_edit} style={{ margin: 0 }}>
          {t("delete.huybo")}
        </Button>
      ),
    }).then(async () => {
      try {
        const res: ListResponseExam<ListExam> = await managerTestApi.deleteExam(exam.id);
        if (res.responseCode === "00") {
          toast.success(`${t("managerTest.xoabaithithanhcong")}`);
          dispatch(fetchListExam(filter));
        }
      } catch (error) { }
    });
  };

  const handleCheckDisable = (exam: ListExam) => {
    const timeStartExam = new Date(exam.startDate).getTime();
    const difference = moment(timeStartExam).diff(moment(), "minutes");
    if (difference < 1) {
      return true;
    }
    return false;
  };

  const handleCheckHiddenAnswer = (exam: ListExam) => {
    if (exam?.isForcedToDisplayAnswers) return false;
    const timeStartExam = new Date(exam.hiddenAnswerDate).getTime();
    const difference = moment(timeStartExam).diff(moment(), "minutes");
    if (difference < 1) {
      return true;
    }
    return false;
  };

  const handleParseExamName = (exam: ListExam) => {
    if (!exam?.classIdList || !classList) return "";
    const listIdExam = exam.classIdList.split(',').filter((item: string) => Boolean(item));
    if (!listIdExam || listIdExam.length === 0) return "";
    const names = classList
      .filter((item: IClass) => listIdExam.includes(String(item.id)))
      .map(item => item.name);

    return names.join(', ');
  };

  const handleUpdateHiddenAnswer = async (exam: ListExam) => {
    try {
      const res = await managerTestApi.updateExamV2({ isForcedToDisplayAnswers: !exam.isForcedToDisplayAnswers }, exam.id);
      if (res.responseCode === "00") {
        if (exam.isForcedToDisplayAnswers) {
          toast.success('Khóa đáp án thành công');
        } else {
          toast.success('Hiển thị đáp án thành công');
        }
        dispatch(fetchListExam(filter));
      }
    } catch (error) { }
  }

  const handleExportexam = async (exam: ListExam) => {
    const token = localStorage.getItem(TOKEN);
    try {
      const res: AxiosResponse = await axios({
        method: "GET",
        url: `${BASE_URL}/exam/export/${exam.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "blob",
        },
        responseType: "arraybuffer",
      });
      if (res.data.responseDescription) {
        toast.error(t("file.xuatthatbai"));
        return;
      }
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      FileDownload(blob, `${exam.examTitle}-${dateTimeToFormatYYYY(exam.createdAt)}.docx`);
      toast.success(t("file.xuatthanhcong"));
    } catch (error) { }
  }

  return (
    <div ref={containerRef}>
      <Box className={classes.pageWrapper}>
        <Box className={classes.background}>
          <Typography variant="subtitle2">{t("managerTest.danhsachdethi")}</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon style={{ fontSize: 20 }} />}
            style={{
              background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
              color: "#FFFFFF",
              borderRadius: 12,
              height: 40,
              padding: "0 20px",
              fontWeight: 700,
              fontSize: "0.875rem",
              textTransform: "none",
              boxShadow: "0 4px 14px rgba(37, 99, 235, 0.35)",
              zIndex: 2,
            }}
            onClick={() => navigate("/admin/manager-test/create-new")}
          >
            Thêm đề thi mới
          </Button>
        </Box>

        {/* Sticky Filter Toolbar */}
        <Box className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
          <Box style={{ flex: 1, minWidth: 260, maxWidth: isMobile ? "100%" : 360 }}>
            <InputSearch
              filter={filter}
              onSearchChange={handleSearchChange}
              label="Tìm kiếm theo tiêu đề đề thi..."
            />
          </Box>

          <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12, width: isMobile ? "100%" : "auto" }}>
            <FormControl variant="outlined" size="small" style={{ minWidth: 160, flex: isMobile ? 1 : "initial" }}>
              <InputLabel id="exam-type-filter-label" style={{ fontWeight: 600, fontSize: 13 }}>
                Hình thức thi
              </InputLabel>
              <Select
                labelId="exam-type-filter-label"
                value={filter.type || ""}
                onChange={(e) => handleFilterTypeChange(e.target.value as string)}
                label="Hình thức thi"
                style={{ borderRadius: 10, backgroundColor: "#FFFFFF", fontSize: 13, fontWeight: 600 }}
              >
                <MenuItem value="">Tất cả hình thức</MenuItem>
                <MenuItem value="CHOICE">Trắc nghiệm</MenuItem>
                <MenuItem value="TYPING">Tự luận</MenuItem>
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" style={{ minWidth: 180, flex: isMobile ? 1 : "initial" }}>
              <InputLabel id="exam-class-filter-label" style={{ fontWeight: 600, fontSize: 13 }}>
                Lớp học
              </InputLabel>
              <Select
                labelId="exam-class-filter-label"
                value={filter.classId || ""}
                onChange={(e) => handleFilterClassChange(e.target.value as string)}
                label="Lớp học"
                style={{ borderRadius: 10, backgroundColor: "#FFFFFF", fontSize: 13, fontWeight: 600 }}
              >
                <MenuItem value="">Tất cả lớp học</MenuItem>
                {classList?.map((item: IClass) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Ngày thi"
              type="date"
              size="small"
              variant="outlined"
              value={filter.startDateFrom || ""}
              onChange={(e) =>
                dispatch(
                  setFilterListExam({
                    ...filter,
                    startDateFrom: e.target.value || undefined,
                    startDateTo: e.target.value || undefined,
                    page: 0,
                  })
                )
              }
              InputLabelProps={{ shrink: true, style: { fontWeight: 600, fontSize: 13 } }}
              inputProps={{ style: { borderRadius: 10, fontSize: 13, padding: "8.5px 12px" } }}
              style={{ minWidth: 150, flex: isMobile ? 1 : "initial", backgroundColor: "#FFFFFF", borderRadius: 10 }}
            />

            <TextField
              label="Ngày tạo đề"
              type="date"
              size="small"
              variant="outlined"
              value={filter.createdFrom || ""}
              onChange={(e) =>
                dispatch(
                  setFilterListExam({
                    ...filter,
                    createdFrom: e.target.value || undefined,
                    createdTo: e.target.value || undefined,
                    page: 0,
                  })
                )
              }
              InputLabelProps={{ shrink: true, style: { fontWeight: 600, fontSize: 13 } }}
              inputProps={{ style: { borderRadius: 10, fontSize: 13, padding: "8.5px 12px" } }}
              style={{ minWidth: 150, flex: isMobile ? 1 : "initial", backgroundColor: "#FFFFFF", borderRadius: 10 }}
            />

            {(filter.type || filter.classId || filter.startDateFrom || filter.createdFrom || filter.name || filter.search) && (
              <Button
                size="small"
                onClick={() =>
                  dispatch(
                    setFilterListExam({
                      page: 0,
                      size: 10,
                    })
                  )
                }
                style={{
                  color: "#EF4444",
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  textTransform: "none",
                  borderRadius: 8,
                  padding: "0 10px",
                  backgroundColor: "#FEF2F2",
                  border: "1px solid #FCA5A5",
                  height: 36,
                  minWidth: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                ✕ Xóa bộ lọc
              </Button>
            )}
          </Box>
        </Box>

      <Box>
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={8} style={{ minHeight: "350px" }}>
            <CircularProgress style={{ color: "#2563EB" }} size={48} />
            <Typography variant="body1" style={{ marginTop: 16, color: "#0F172A", fontWeight: 600 }}>
              {t("managerTest.dangtaidanhsachdethi")}
            </Typography>
          </Box>
        ) : listExam?.totalPages > 0 ? (
          <>
            <TableContainer component={Paper} className={classes.container}>
            <Table stickyHeader style={{ minWidth: "100%" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" width="60px">
                    {t("stt")}
                  </StyledTableCell>
                  <StyledTableCell align="left" width="420px">
                    Thông tin đề thi
                  </StyledTableCell>
                  <StyledTableCell align="center" width="260px">
                    Cấu trúc & Hình thức
                  </StyledTableCell>
                  <StyledTableCell align="center" width="340px">
                    {t("thaotac")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listExam?.content.map((exam, index) => (
                  <TableRow
                    key={exam.id}
                    hover
                    onClick={() => navigate(`/admin/manager-test/exam/${exam.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* STT */}
                    <StyledTableCell align="center" component="th" scope="exam">
                      <Typography style={{ fontWeight: 700, color: "#334155", fontSize: "0.875rem" }}>
                        {listExam.size * listExam.number + index + 1}
                      </Typography>
                    </StyledTableCell>

                    {/* Thông tin đề thi (Tên đề, Ngày thi có giờ, Ngày tạo, Lớp áp dụng) */}
                    <StyledTableCell align="left">
                      <Typography style={{ fontWeight: 700, color: "#0F172A", fontSize: "0.95rem", marginBottom: 4 }}>
                        {exam?.examTitle}
                      </Typography>
                      {exam?.startDate && (
                        <Box style={{ marginBottom: 4 }}>
                          <Chip
                            label={`Ngày thi: ${moment(exam.startDate).format("HH:mm - DD/MM/YYYY")}`}
                            size="small"
                            style={{
                              backgroundColor: "#EFF6FF",
                              color: "#2563EB",
                              fontWeight: 700,
                              fontSize: "0.75rem",
                              borderRadius: 4,
                              height: 22,
                            }}
                          />
                        </Box>
                      )}
                      <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 6 }}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 500 }}>
                          Tạo ngày: {dateTimeToFormatYYYY(exam.createdAt)}
                        </Typography>
                        <Typography variant="caption" style={{ color: "#CBD5E1" }}>
                          •
                        </Typography>
                        <Typography variant="caption" style={{ color: "#475569", fontWeight: 600 }}>
                          Lớp: {exam?.classList?.length === classList?.length ? "Tất cả" : handleParseExamName(exam) || "Tất cả"}
                        </Typography>
                      </Box>
                    </StyledTableCell>

                    {/* Cấu trúc & Hình thức (Hàng 1: Hình thức + Thời gian | Hàng 2: Số câu + Điểm) */}
                    <StyledTableCell align="center">
                      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{ gap: 6 }}>
                        <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 6 }}>
                          <Chip
                            label={
                              exam?.type?.toUpperCase() === "TYPING" || exam?.type?.toUpperCase() === "ESSAY"
                                ? `${t("managerTest.tuluan")}`
                                : `${t("managerTest.tracnghiem")}`
                            }
                            size="small"
                            style={{
                              backgroundColor:
                                exam?.type?.toUpperCase() === "TYPING" || exam?.type?.toUpperCase() === "ESSAY"
                                  ? "#FEF3C7"
                                  : "#EEF2FF",
                              color:
                                exam?.type?.toUpperCase() === "TYPING" || exam?.type?.toUpperCase() === "ESSAY"
                                  ? "#B45309"
                                  : "#4F46E5",
                              fontWeight: 700,
                              borderRadius: 6,
                            }}
                          />
                          <Chip
                            label={timeConvert(Number(exam?.examTime))}
                            size="small"
                            style={{
                              backgroundColor: "#F1F5F9",
                              color: "#475569",
                              fontWeight: 700,
                              borderRadius: 6,
                            }}
                          />
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 6 }}>
                          <Chip
                            label={`${exam?.examQuestions?.length || 0} câu`}
                            size="small"
                            style={{
                              backgroundColor: "#F0FDF4",
                              color: "#166534",
                              fontWeight: 700,
                              borderRadius: 6,
                            }}
                          />
                          <Chip
                            label={`${exam?.totalPoint || 0} điểm`}
                            size="small"
                            style={{
                              backgroundColor: "#E0F2FE",
                              color: "#0369A1",
                              fontWeight: 700,
                              borderRadius: 6,
                            }}
                          />
                        </Box>
                      </Box>
                    </StyledTableCell>

                    <StyledTableCell align="center" width="340px" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                      <Box display="flex" flexWrap="wrap" justifyContent="center" alignItems="center" style={{ gap: 6, width: 320, margin: "0 auto" }}>
                        <Button
                          className={classes.btn_listExam}
                          style={{
                            backgroundColor: "#4F46E5",
                            color: "#FFFFFF",
                            borderColor: "#4338CA",
                            fontWeight: 700,
                            margin: 0,
                            flex: "1 1 30%",
                            whiteSpace: "nowrap",
                          }}
                          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            navigate(`/admin/manager-test/exam/results/${exam.id}`);
                          }}
                        >
                          Kết quả thi
                        </Button>
                        <Button
                          className={classes.btn_listExam}
                          onClick={(e) => {
                            e.stopPropagation();
                            setRescheduleExam(exam);
                          }}
                          style={{
                            color: "#D97706",
                            backgroundColor: "#FFFBEB",
                            borderColor: "#FDE68A",
                            margin: 0,
                            flex: "1 1 30%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {t("managerTest.doilichthi")}
                        </Button>
                        <Button
                          className={classes.btn_edit}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/admin/manager-test/exam/edit/${exam.id}`);
                          }}
                          disabled={handleCheckDisable(exam)}
                          style={{ margin: 0, flex: "1 1 30%", whiteSpace: "nowrap" }}
                        >
                          {t("admin.chinhsua")}
                        </Button>
                        <Button
                          className={classes.btn_listExam}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUpdateHiddenAnswer(exam);
                          }}
                          style={{
                            color: handleCheckHiddenAnswer(exam) ? "#047857" : "#DC2626",
                            backgroundColor: handleCheckHiddenAnswer(exam) ? "#ECFDF5" : "#FEF2F2",
                            borderColor: handleCheckHiddenAnswer(exam) ? "#A7F3D0" : "#FCA5A5",
                            margin: 0,
                            flex: "1 1 30%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {handleCheckHiddenAnswer(exam) ? 'Hiện đáp án' : 'Khóa đáp án'}
                        </Button>
                        <Button
                          className={classes.btn_listExam}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleExportexam(exam);
                          }}
                          style={{
                            color: "#16A34A",
                            backgroundColor: "#F0FDF4",
                            borderColor: "#BBF7D0",
                            margin: 0,
                            flex: "1 1 30%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Xuất đề thi
                        </Button>
                        <Button
                          className={classes.btn_delete}
                          style={{ margin: 0, flex: "1 1 30%", whiteSpace: "nowrap" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteExam(exam);
                          }}
                        >
                          {t("managerTest.xoabaithi")}
                        </Button>
                      </Box>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Mobile/Tablet View: Grid View */}
          <Box className={classes.mobileListView}>
            {listExam?.content.map((exam, index) => (
              <Box
                key={exam.id}
                className={classes.mobileCard}
                onClick={() => navigate(`/admin/manager-test/exam/${exam.id}`)}
                style={{ cursor: "pointer" }}
              >
                {/* Card Header: Title & Index */}
                <Box className={classes.mobileCardHeader}>
                  <Box>
                    <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                      {exam.examTitle}
                    </Typography>
                    <Typography variant="caption" style={{ color: "#64748B" }}>
                      STT: {listExam.size * listExam.number + index + 1} | Lớp: {handleParseExamName(exam) || "Tất cả"}
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body: Info rows */}
                <Box className={classes.mobileCardBody}>
                  {exam?.startDate && (
                    <Box className={classes.mobileCardRow}>
                      <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                        NGÀY THI
                      </Typography>
                      <Chip
                        label={moment(exam.startDate).format("HH:mm - DD/MM/YYYY")}
                        size="small"
                        style={{
                          backgroundColor: "#EFF6FF",
                          color: "#2563EB",
                          fontWeight: 700,
                          borderRadius: 6,
                        }}
                      />
                    </Box>
                  )}
                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      NGÀY TẠO ĐỀ
                    </Typography>
                    <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                      {dateTimeToFormatYYYY(exam.createdAt)}
                    </Typography>
                  </Box>

                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      THỜI GIAN LÀM BÀI
                    </Typography>
                    <Chip
                      label={timeConvert(Number(exam?.examTime))}
                      size="small"
                      style={{
                        backgroundColor: "#E2E8F0",
                        color: "#334155",
                        fontWeight: 700,
                        borderRadius: 6,
                      }}
                    />
                  </Box>

                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      ĐIỂM
                    </Typography>
                    <Chip
                      label={exam?.totalPoint || 0}
                      size="small"
                      style={{
                        backgroundColor: "#E0F2FE",
                        color: "#0369A1",
                        fontWeight: 700,
                        borderRadius: 6,
                      }}
                    />
                  </Box>
                </Box>

                {/* Card Actions */}
                <Box className={classes.mobileCardActions} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                  <Button
                    className={classes.btn_listExam}
                    style={{
                      margin: 0,
                      backgroundColor: "#4F46E5",
                      color: "#FFFFFF",
                      borderColor: "#4338CA",
                      fontWeight: 700,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/admin/manager-test/exam/results/${exam.id}`);
                    }}
                  >
                    Kết quả thi
                  </Button>
                  <Button
                    className={classes.btn_listExam}
                    style={{
                      margin: 0,
                      color: "#D97706",
                      backgroundColor: "#FFFBEB",
                      borderColor: "#FDE68A",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setRescheduleExam(exam);
                    }}
                  >
                    {t("managerTest.doilichthi")}
                  </Button>
                  <Button
                    className={classes.btn_edit}
                    style={{ margin: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/admin/manager-test/exam/edit/${exam.id}`);
                    }}
                    disabled={handleCheckDisable(exam)}
                  >
                    Sửa
                  </Button>
                  <Button
                    className={classes.btn_listExam}
                    style={{
                      margin: 0,
                      color: handleCheckHiddenAnswer(exam) ? "#047857" : "#DC2626",
                      backgroundColor: handleCheckHiddenAnswer(exam) ? "#ECFDF5" : "#FEF2F2",
                      borderColor: handleCheckHiddenAnswer(exam) ? "#A7F3D0" : "#FCA5A5",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdateHiddenAnswer(exam);
                    }}
                  >
                    {handleCheckHiddenAnswer(exam) ? 'Hiện đ.án' : 'Khóa đ.án'}
                  </Button>
                  <Button
                    className={classes.btn_listExam}
                    style={{
                      margin: 0,
                      color: "#16A34A",
                      backgroundColor: "#F0FDF4",
                      borderColor: "#BBF7D0",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleExportexam(exam);
                    }}
                  >
                    Xuất đề
                  </Button>
                  <Button
                    className={classes.btn_delete}
                    style={{ margin: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteExam(exam);
                    }}
                  >
                    Xóa
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
          </>
        ) : (
          <EmptyComponent isBorder={false} />
        )}
        {listExam?.totalPages > 1 && (
          <Box className={classes.paginationContainer}>
            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
              {t("managerTest.tongdethi")}: {listExam.totalElements}
            </Typography>
            <Pagination
              count={Math.ceil(listExam?.totalElements / listExam?.size)}
              page={listExam?.number + 1}
              variant="outlined"
              color="primary"
              shape="rounded"
              size={isMobile ? "small" : "medium"}
              siblingCount={isMobile ? 0 : 1}
              onChange={(e, page) => handleChangePage(page)}
            />
          </Box>
        )}
      </Box>
      <RescheduleExamModal
        open={rescheduleExam != null}
        exam={rescheduleExam}
        onClose={() => setRescheduleExam(null)}
        onSuccess={() => dispatch(fetchListExam(filter))}
      />
      </Box>
    </div>
  );
}
